import { isEmpty } from 'lodash'
import { getKeyByValue } from '~~/utils'

const POP_FLOW = 'POP_FLOW'
const PUSH_FLOW = 'PUSH_FLOW'
const SET_CANCEL_REASONS = 'SET_CANCEL_REASONS'

const SET_USER = 'user/SET_USER'

function randomArray(array) {
  const newArray = JSON.parse(JSON.stringify(array))
  let currentIndex = newArray.length
  let temporaryValue
  let randomIndex

  while (currentIndex !== 0) {
    randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex -= 1

    temporaryValue = newArray[currentIndex]
    newArray[currentIndex] = newArray[randomIndex]
    newArray[randomIndex] = temporaryValue
  }
  return newArray
}

function randomizeOptions(baseOptions) {
  const randomizedOptions = baseOptions.map((option, idx) => {
    return idx > 5 && option.subOptions.length
      ? {
          ...option,
          subOptions: randomArray(option.subOptions)
        }
      : option
  })

  return randomArray(randomizedOptions)
}

export const state = () => ({
  isCanceled: false,
  options: [],
  flow: [],
  certificateExpirationDate: ''
})

export const actions = {
  getCancelReasons({ commit, state }, payload) {
    if (isEmpty(state.options)) {
      payload[2].subOptions = []

      // TODO: Add pages
      payload[4].subOptions.splice(0, 1)
      payload[5].subOptions.splice(0, 1)

      commit(SET_CANCEL_REASONS, randomizeOptions(payload))
    }
  },

  async cancelSubscription({ commit }, payload) {
    const body = {
      toggle: true
    }

    try {
      const user = await this.$axios.$put('/api/user/subscription', body)

      commit(SET_USER, user, { root: true })
    } catch (err) {
      console.error(err)
    }
  },

  popFlow({ commit }) {
    commit(POP_FLOW)
  },

  pushFlow({ commit }, payload) {
    commit(PUSH_FLOW, payload)
  },

  async sendCustomerFlow({ state, commit, rootGetters }) {
    const body = {
      isCanceled: rootGetters['user/isCanceled'],
      flow: state.flow
    }

    try {
      await this.$axios.post('/api/cancel/flow', body)
      commit('resetFlow')
    } catch (err) {
      console.error(err)
    }
  },

  async sendSurvey({ commit }, payload) {
    try {
      const response = await this.$axios.$post('/api/surveys/cancellation', {
        flow: Object.values(payload).reduce((acc, cur) => acc.concat(cur), [])
      })

      if (response.expirationDate) {
        commit('setCertificateExpirationDate', response.expirationDate)
      }

      return response
    } catch (err) {
      console.error(err)
    }
  }
}

export const mutations = {
  [SET_CANCEL_REASONS](state, payload) {
    state.options = payload
  },

  [PUSH_FLOW](state, payload) {
    state.flow.push({
      step: state.flow.length + 1,
      page_url: window.location.pathname.replace('/my_account', ''),
      answer: payload
    })
  },

  resetFlow(state) {
    state.flow = []
  },

  // TODO: Fix pop
  [POP_FLOW](state) {
    state.flow.pop()
  },

  setCertificateExpirationDate(state, payload) {
    state.certificateExpirationDate = payload
  }
}

export const getters = {
  optionKeys(state) {
    return state.options.reduce((acc, cur) => {
      acc[cur.id] = cur.path.replace('/my_account/cancel/', '')

      return acc
    }, {})
  },

  getOptionsByKey(state, getters) {
    return function (key) {
      const foundKey = getKeyByValue(getters.optionKeys, key)

      return state.options.find(option => option.id == foundKey) || []
    }
  },

  certificateExpirationDate(state) {
    return state.certificateExpirationDate
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
